<template>
  <div>
    <template v-if="statusStatisticData">
      <div class="headline primary--text mb-3">Number of Case Status</div>
      <v-layout :style="{ margin: '-8px' }" wrap>
        <v-flex v-for="(item, index) in items" :key="index" class="pa-2" xs12 sm6 md3 lg2>
          <v-card :style="{ height: '100%' }">
            <v-layout column :style="{ height: 'inherit' }">
              <v-flex shrink>
                <v-card-title class="subheading">{{ item.text | capitalize }}</v-card-title>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-card-text class="headline">
                  <template v-if="loading">
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                  </template>
                  <template v-else>
                    {{ item.value }}
                  </template>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page.js'
export default {
  props: {
    statusStatisticData: {
      type: Object,
      default: () => undefined
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCustomerSupportService: 'isCustomerSupportService',
      customerStatusOptions: 'customerStatusOptions'
    }),
    items() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions.map((item) => {
          return {
            text: item.label,
            value:
              this.statusStatisticData && this.statusStatisticData[item.value]
                ? this.statusStatisticData[item.value]
                : 0
          }
        })
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption
            .filter((item) => item.value != 'open')
            .map((item) => {
              return {
                text: item.label,
                value:
                  this.statusStatisticData && this.statusStatisticData[item.value]
                    ? this.statusStatisticData[item.value]
                    : 0
              }
            })
        } else {
          return status
            .filter((item) => item.value != 'open')
            .map((item) => {
              return {
                text: item.label,
                value:
                  this.statusStatisticData && this.statusStatisticData[item.value]
                    ? this.statusStatisticData[item.value]
                    : 0
              }
            })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/overview/StatusStatistics.vue